import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import swal from "sweetalert2";
import i18n from '../../utils/i18n';
export const connectTo = (mapStateToProps, actions, container) => {
    const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch)
    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(container);
};

/**
 * 
 * @param {required} title 
 * @param {required} message 
 * @param {optional} type 
 * @param {required} isLoading 
 * 
 * If you are using swalOpen isLoading true option, please do not forget to use swalClose.
 */
export const swalOpen = (title, message, type ,isLoading, index = 0) => {
    let messageWithFormIndex = index > 0 
    ? (i18n.t('form_index',{index: index + 1}) + i18n.t(message) )
    : i18n.t(message) ; 
    if(isLoading){
        swal({
            title: i18n.t(title),
            text: messageWithFormIndex,
            onOpen: function () {
                swal.showLoading()
            }
        }).catch(swal.noop);
    }else {
        swal({
            title: i18n.t(title),
            text: messageWithFormIndex,
            type: type,
            timer: 4000,
            showCloseButton: false
        }).catch(swal.noop);
    }
   
}

export const swalClose = () => swal.close();
